
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Button, Col, Row, } from 'react-bootstrap'
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls'
import * as Yup from "yup";
import PersonalDetailsReport from '../AppplicationForm/PersonalDetailsReport'
import Swal from 'sweetalert2'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { ERROR_MSG } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { useDispatch, useSelector } from 'react-redux';
import { FaCopy } from 'react-icons/fa';
import { IoCheckmarkSharp } from "react-icons/io5";
import { BasicDetailsCheck, DegreeCheck, EducationalCheck, InterCheck, PGCheck, PQCheck, SSCCheck, TETCheck } from '../Papers/TetPreview';

export const appValidationSchema = Yup.object().shape({
        personalDetailsCheck: Yup.boolean().required(ERROR_MSG)
            .test("isTrue", ERROR_MSG, (value) => {
                if (value === false) return false;
                return true;
            }).nullable(),
        basicEducationCheck: Yup.boolean().required(ERROR_MSG).test("isTrue", ERROR_MSG, (value) => {
            if (value === false) return false;
            return true;
        }).nullable(),
        sscCheck: Yup.boolean().required(ERROR_MSG).test("isTrue", ERROR_MSG, (value) => {
            if (value === false) return false;
            return true;
        }).nullable(),
        interCheck: Yup.boolean().required(ERROR_MSG).test("isTrue", ERROR_MSG, (value) => {
            if (value === false) return false;
            return true;
        }).nullable(),
        ugCheck: Yup.boolean().required(ERROR_MSG).test("isTrue", ERROR_MSG, (value) => {
            if (value === false) return false;
            return true;
        }).nullable(),
        pgCheck: Yup.boolean().required(ERROR_MSG).test("isTrue", ERROR_MSG, (value) => {
            if (value === false) return false;
            return true;
        }).nullable(),
        pqCheck: Yup.boolean().required(ERROR_MSG).test("isTrue", ERROR_MSG, (value) => {
            if (value === false) return false;
            return true;
        }).nullable(),
        postCheck: Yup.boolean().required(ERROR_MSG).test("isTrue", ERROR_MSG, (value) => {
            if (value === false) return false;
            return true;
        }).nullable(),
        tetCheck: Yup.boolean().required(ERROR_MSG).test("isTrue", ERROR_MSG, (value) => {
            if (value === false) return false;
            return true;
        }).nullable(),
    });
    export const appInitValues={
            "personalDetailsCheck": "",
            "basicEducationCheck": "",
            "sscCheck": "",
            "interCheck": "",
            "ugCheck": "",
            "pgCheck": "",
            "pqCheck": "",
            "postCheck": "",
            "tetCheck": ''
        }
export default function Preview({ handleNext, setShow }) {

    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
    const dispatch = useDispatch();
    const [postData, setPostData] = useState()
    const getpostDataFunction = () => {
        let villUrl = config.url.DSC_URL + "candidate-posts";
        CommonAxiosGet(villUrl).then((response) => {
            if (response?.data.status === true) {
                setPostData(response?.data?.candidateposts)
            }
            else {
                setPostData([])
            }
        });
    };
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: appInitValues,
        onSubmit: (values) => {
            if (postData?.length > 0) {
                Swal.fire({
                    title: 'Are you Sure Want to Submit?',
                    text: "Details furnished in the application are final. Subsequent requests for corrections will not be entertained for wrong filling of application.",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Submit",
                }).then((res) => {
                    if (res.isConfirmed) {
                        let url = config.url.DSC_URL + "candidate-confirmation"
                        CommonAxiosPost(url, values).then((ress) => {
                            if (ress?.data?.status === true) {
                                Sweetalert('Successfully Confirmed', "success")
                                dispatch({
                                    type: "SHOW_TAB_DETAILS",
                                    payload: {
                                        latestTab: 3,
                                        confirm: true
                                    }
                                })
                                handleNext()
                            }
                            else {
                                Sweetalert(ress?.data?.sdesc, "error")
                            }
                        })
                    }
                    else {
                        setShow(false)
                    }
                })
            }
            else {

                Swal.fire({

                    html: `As per the data provided (Academic Details/Professional qualifications/Other).
                    You are not eligible for any notified posts. Please Check G.O. and your Qualification details once for the Eligibility Criteria <br/>
                     <b>For any queries contact :  1234567890</b>`,
                    icon: "warning",
                    confirmButtonColor: '#3085d6',
                })
            }

        },
        validationSchema: appValidationSchema,
    })
    const [showUgPgPqData, setUgPgPqData] = useState([])
    const [showSevenData, setSevenData] = useState([])
    const [showSSCInterData, setSSCInterData] = useState([])
    const [showTETData, setTETData] = useState([])

    const [showData, setData] = useState()

    function getStudyData() {
        let Url = config.url.DSC_URL + "candidate-study-details"
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true) {
                if (res?.data?.sevenyear_status === true) {
                    setSevenData(res?.data?.sevenyear)
                }
                if (res?.data?.ugpgpq_status === true) {
                    setUgPgPqData(res?.data?.ugpgpq)
                }
                if (res?.data?.sscinter_status === true) {
                    setSSCInterData(res?.data?.sscinter[0])
                }
                if (res?.data?.tet_status === true) {
                    setTETData(res?.data?.tet)
                }
                if (res?.data?.candidatereg_status === true) {
                    setData(res?.data?.candidatereg[0])
                    const casteId = res?.data?.candidatereg[0]?.certificate_id;
                    if (casteId) {
                        localStorage.setItem("caste", casteId);
                    } else {
                        console.warn("No certificate_id found");
                    }

                }
            }
        })
    }
    useEffect(() => {

        getStudyData()
        getpostDataFunction()
    }, [])
    const [copied, setCopied] = useState(false);
    const handleCopyText = () => {
        const textToCopy = document.getElementById('textToCopy').innerText;
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                console.log('Text copied to clipboard');
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 3000);
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    };
    return (
        <React.Fragment>
            <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between px-0">
                    <div className="heading-main">
                        <h3 className="main-title">Candidate Details Confirmation - <span style={{ color: 'brown' }} id='textToCopy'>{loginreducer?.username}</span>
                            &nbsp; {copied ? <><IoCheckmarkSharp color='green' size={30} />Copied! </> : <FaCopy onClick={() => { handleCopyText(); }} />}
                        </h3>
                    </div>
                </Col>
            </Row>
            <FormikProvider value={Formik}>
              <Form className="form-section" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange}>
              <BasicDetailsCheck Formik={Formik} showData={showData}/>
              <EducationalCheck showSevenData={showSevenData} showData={showData}/>
              <SSCCheck showSSCInterData={showSSCInterData}/>
              <InterCheck showSSCInterData={showSSCInterData}/>
              <DegreeCheck showUgPgPqData={showUgPgPqData}/>
              <PGCheck showUgPgPqData={showUgPgPqData}/>
              <PQCheck showUgPgPqData={showUgPgPqData}/>
              <TETCheck showTETData={showTETData}/>
              <PostDetailsCheck postData={postData}/>
            </Form>
            </FormikProvider>
        </React.Fragment>
    )
}
export const PostDetailsCheck = (props)=>{
    const{postData}=props;
    return(<>
         <div className="personal-head mt-2">
                        <span>Eligible Posts Details</span>
                    </div>
                    <div className="personal-row personal-roweducation">
                        <div className="table-responsive px-1 mb-3">
                            <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                style={{ border: '2px solid lightblue', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Post</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {postData ? postData?.map((data, index) => {
                                        return (
                                            <tr key={index} id={index}>
                                                <td>{index + 1}.</td>
                                                <td>{data?.eli_post_name}</td>
                                            </tr>
                                        )
                                    }) : <></>}

                                </tbody>
                                <tfoot>
                                    <tr className='text-end'><td colSpan={5}>
                                        {postData?.length > 0 ? <>
                                            <ErrorMessage
                                                name="postCheck"
                                                component="span"
                                                className="text-error"
                                            /> &nbsp;
                                            <button className='btn btn-outline-light' type='button'
                                                style={{ fontSize: "14px", border: "3px solid #f99120", color: 'black' }}>
                                                <Field
                                                    name="postCheck"
                                                    type="checkbox"
                                                    style={{ width: '17px', height: '17px' }}
                                                />&nbsp;Verified & Correct
                                            </button>
                                        </>
                                            : <b className='text-center text-danger'>** Based on your qualifications and the provided data, you are not eligible for any of the notified posts. &emsp;</b>}

                                    </td></tr>
                                </tfoot>
                            </table>
                        </div>
                        <div className='float-end mb-4 mt-2 px-1'>
                            <Button variant="success" type="submit" className="submit-btn btn-success" >
                                Confirm & save
                            </Button>
                        </div>
                    </div>
    </>)
}
